import { render } from "./Settings.vue?vue&type=template&id=3960c006&scoped=true&ts=true"
import script from "./Settings.vue?vue&type=script&lang=ts"
export * from "./Settings.vue?vue&type=script&lang=ts"

import "./Settings.vue?vue&type=style&index=0&id=3960c006&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/chronicle/chronicle/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3960c006"]])

export default __exports__